import React, { Component } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { fieldPropTypes } from "redux-form/lib/propTypes";
import isEqual from "lodash/isEqual";

import "./PaymentMethodField.scss";
import Image from "../../../component/Image";

/**
 * PaymentMethodField
 *
 <Field name="checkout.payment.type" id="checkout-payment-type" component="input" type="radio" value={p.get('id')} parse={parseInt} />
 */
class PaymentMethodField extends Component {
  static propTypes = {
    ...fieldPropTypes,
    paymentMethods: PropTypes.instanceOf(Immutable.List).isRequired
  };

  static defaultProps = {};

  state = {
    style: {}
  };

  componentWillMount() {
    if (window.matchMedia && window.matchMedia("(max-width: 768px)").matches) {
      this.setState({
        style: {}
      });
    }
  }

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  render() {
    const { input, meta } = this.props;
    return (
      <div className={`Cart__Checkout__PaymentMethods ${meta.error && meta.touched ? " has-danger" : ""}`}>
        {/* eslint-disable jsx-a11y/label-has-for */
        this.props.paymentMethods.map(p => (
          <label
            className="Cart__Checkout__PaymentMethod__Item"
            htmlFor={`checkout-payment-type-${p.get("id")}`}
            style={this.state.style}
            key={p.get("id")}
          >
            <div className="Cart__Checkout__PaymentMethod__Item__Image">
              <Image src={`/img/paymentMethod/${p.get("image")}`} />
            </div>
            <div className="Cart__Checkout__PaymentMethod__Item__Title">{p.get("title")}</div>
            <input
              {...input}
              id={`checkout-payment-type-${p.get("id")}`}
              type="radio"
              value={p.get("id")}
              checked={input.value === p.get("id")}
            />
            <div className="Cart__Checkout__PaymentMethod__Item__Input" />
          </label>
        ))
        /* eslint-enable jsx-a11y/label-has-for */
        }
        {meta.error && meta.touched && (
          <div className="col-12 invalid-feedback">{this.props.t("Select a payment method")}</div>
        )}
      </div>
    );
  }
}

export default PaymentMethodField;
